<template>
  <ElForm
    label-position="top"
    hide-required-asterisk
    class="new-app-support-info-form"
    :model="info"
    :rules="formRules"
  >
    <ElFormItem
      prop="email"
      :error="errors.email"
      :label="$t('APPS.DRAFT.STEPS.SUPPORT_INFO.EMAIL')"
    >
      <ElInput v-model="info.email" class="text-latin" dir="ltr" tabindex="2" />

      <small class="text-disabled">
        {{ $t('APPS.DRAFT.STEPS.SUPPORT_INFO.EMAIL_HINT') }}
      </small>
    </ElFormItem>

    <OptionalFormItem
      prop="phone"
      :error="errors.phone"
      :label="$t('APPS.DRAFT.STEPS.SUPPORT_INFO.PHONE')"
      @remove="info.phone = ''"
    >
      <ElInput ref="firstInput" v-model="info.phone" tabindex="1" />

      <small class="text-disabled">
        {{ $t('APPS.DRAFT.STEPS.SUPPORT_INFO.PHONE_HINT') }}
      </small>
    </OptionalFormItem>

    <OptionalFormItem
      prop="homepageFa"
      :error="errors.homepageFa"
      :label="$t('APPS.DRAFT.STEPS.SUPPORT_INFO.PERSIAN_WEBSITE')"
      @remove="info.homepageFa = ''"
    >
      <ElInput v-model="info.homepageFa" tabindex="3" />
    </OptionalFormItem>

    <OptionalFormItem
      prop="homepageEn"
      :error="errors.homepageEn"
      :label="$t('APPS.DRAFT.STEPS.SUPPORT_INFO.ENGLISH_WEBSITE')"
      @remove="info.homepageEn = ''"
    >
      <ElInput
        v-model="info.homepageEn"
        class="text-latin"
        dir="ltr"
        tabindex="4"
      />

      <small class="text-disabled">
        {{ $t('APPS.DRAFT.STEPS.SUPPORT_INFO.ENGLISH_WEBSITE_HINT') }}
      </small>
    </OptionalFormItem>
  </ElForm>
</template>

<script>
import OptionalFormItem from '@@/common/OptionalFormItem';
import requiredRule from '@/utils/validation-rules/required';
import emailRule from '@/utils/validation-rules/email';

export default {
  name: 'SupportInfoForm',
  components: { OptionalFormItem },

  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      info: {
        phone: '',
        email: '',
        homepageFa: '',
        homepageEn: '',
      },
    };
  },

  computed: {
    formRules() {
      return {
        email: [requiredRule(), emailRule()],
      };
    },
  },

  watch: {
    info: {
      deep: true,
      handler(value) {
        this.$emit('input', { ...value });
      },
    },
  },

  mounted() {
    this.info = {
      ...this.info,
      ...this.value,
    };

    this.$refs.firstInput?.focus();
  },
};
</script>

<style lang="scss">
.new-app-support-info-form {
  max-width: 500px;
}
</style>
